import React from 'react';
import { useParams } from 'react-router-dom';

import EventDetailsV2Container from '@totem/components/services/threats/eventsDashboard/details/EventDetailsV2Container';
import EventDetailsV2Layout from '@totem/components/services/threats/eventsDashboard/details/EventDetailsV2Layout';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const EventDetailsV2Page = () => {
  const { id } = useParams();

  return (
    <ContentLayout>
      <EventDetailsV2Container eventId={id}>
        <EventDetailsV2Layout />
      </EventDetailsV2Container>
    </ContentLayout>
  );
};

export default EventDetailsV2Page;
